import { GlobalAppState } from '@model/state';

export const getExtrasOptions = (state: GlobalAppState) => state.extrasOptions.data;
export const getExtrasOptionsLoading = (state: GlobalAppState) => state.extrasOptions.loading;
